@if (isPublicNavigationEnabled()) {
  <div class="footer-logged-out" [attr.theme]="theme()">
    <a data-track href="https://www.fortherecord.com/policies/" target="_blank">Terms & Conditions</a>
    <a data-track href="https://www.fortherecord.com/policies/" target="_blank">Privacy Policy</a>
  </div>
} @else {
  <div class="footer-logged-out__legacy">
    <div class="row align-items-center justify-content-between">
      <ftr-logo [theme]="logoThemes.White" [size]="logoSizes.Legacy" />
      <ftr-footer-help-links />
    </div>
  </div>
}
